import { render, staticRenderFns } from "./CategoryCounter.vue?vue&type=template&id=a04763aa"
import script from "./CategoryCounter.vue?vue&type=script&lang=js"
export * from "./CategoryCounter.vue?vue&type=script&lang=js"
import style0 from "./CategoryCounter.vue?vue&type=style&index=0&id=a04763aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports